import { makeStyles } from '@mui/styles'
const useStylesDetails = makeStyles(() => ({
  root: {
    width: '100%',
    marginLeft: '5%',
    marginTop: '2%'
  },
  title: {
    fontWeight: 'bold',
    color: '#32332E',
    fontSize: '1.2em'
  },
  boxavatar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatar: {
    height: 60,
    width: 60,
    // color: '#2F3D40'
    backgroundColor: '#2F3D40',
    color: '#FFFFFF'
  },
  gridContainer: {
    // width: '100%',
    paddingTop: '2%',
    marginLeft: 2
  },
  gridContainerButtons: {
    width: '100%',
    paddingTop: '3%',
    marginLeft: 2
  },
  titles: {
    marginTop: 2,
    marginBottom: 1,
    fontSize: '0.85em',
    color: '#1F2024',
    fontWeight: 'bold'
  },
  values: {
    width: '100%',
    fontSize: 14,
    color: '#2F3D40'
  },
  listMobile: {
    display: 'flex',
    alignItems: 'center'
  },
  buttonMobileMore: {
    marginLeft: '2%',
    width: 65,
    height: 20,
    borderRadius: 24,
    backgroundColor: '#fff',
    border: '2px solid #2F3D40',
    boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
  },
  button: {
    width: '35%',
    display: 'flex',
    alignItems: 'flex-end',
    padding: 4,
    textDecoration: 'none',
    cursor: 'pointer',
    color: '#10403B',
    '&:hover': {
      color: '#1C846F'
    }
  },

  iconsButton: {
    fontSize: '1.6rem'
  },
  typographyButton: {
    paddingLeft: 1,
    letterSpacing: 0.5,
    fontSize: '0.79rem',
    fontWeight: 'bold',
    '&:hover': {
      fontSize: '0.80rem'
    }
  },

  containerbuttonClose: {
    // position: 'absolute',
    width: '95%',
    marginLeft: '5%',
    marginTop: '1rem',
    // bottom: 20,
    display: 'flex'
  },
  buttonClose: {
    width: 90,
    height: 35,
    backgroundColor: '#1C846F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    '&:hover': {
      backgroundColor: '#1BF57F'
    },
    justifyContent: 'center',
    alignItems: 'center'
  },
  typographyButtonClose: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16
  },
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 200,
    backgroundColor: 'white',
    padding: 4,
    borderRadius: '8px',
    boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)',
    justifyContent: 'center'
  },
  typographyModal: {
    fontSize: '16px',
    color: '#1F2024',
    fontWeight: 'bold',
    marginLeft: '10%'
  },
  typographyModalSubtitle: {
    fontSize: '13px',
    color: '#1F2024',
    marginLeft: '10%',
    marginTop: '4%'
  },
  typographyField: {
    fontSize: '13px',
    color: '#1F2024',
    marginLeft: '10%',
    marginTop: '4%'
  }
}))

export default useStylesDetails
